import React from "react";
import { useSelector } from "react-redux";

  import Typography from '@mui/material/Typography';

function NoDataMessage() {
  const currLang = useSelector((state) => state.lang.value.currLang);
  const pageDir = useSelector((state) => state.lang.value.pageDir);
  const noDataMessageLang = useSelector((state) => state.lang.value.noDataMessageLang);
  return (


    <Typography id="no-data-message" variant="h6" sx={{
    
      justifyContent: "center",
      alignItems: "center",
      display: "inline",
      height: "90vh",
      width: "74vw",
      top:"45vh",
      direction: `${pageDir[currLang]}`,
     
      // p:"45vh",
      // m:"45vh",
      position: "relative",

    zIndex: 99,

  }}>
      {noDataMessageLang[currLang]}
  </Typography>

  
  );
}

export default  NoDataMessage;
